import React from 'react';
// Import Global Components
import Title from '../../../components/Title';
import Text from '../../../components/Text';
// Import Layouts
import Main from '../../../layouts/Main';
// Import Translations
import { recoverEn } from '../../../i18n/recover';

export default () => (
  <Main>
    <Title
      title={recoverEn['recover-invalidLink-title']}
      titleFor="invalidLink"
      page="recover"
    />
    <Text
      text={recoverEn['recover-invalidLink-text']}
      textFor="invalidLink"
      page="recover"
    />
  </Main>
);
